module.exports = __webpack_public_path__ + "img/hometile_sm.c907ad2f.png";